"use client";
import { IBlocks, IUserData } from "@/types";
import React from "react";
import { cn } from "@/lib/utils";
import type { BlockUpdateFunction } from "./utils/blocks-map";
import AdminPopover from "./utils/AdminPopover";
import {
    BORDER_RADIUS_OPTIONS,
    FONT_SIZE_OPTIONS,
    SHADOW_OPTIONS,
} from "./utils/block-style-classes";

interface Props {
    edit?: boolean;
    block: IBlocks;
    update?: BlockUpdateFunction;
    style: any;
    theme: IUserData["chosen_theme"];
}
export default function BlockText({
    edit,
    block,
    update,
    style,
    theme,
}: Props) {
    const [blockUpdate, setBlockUpdate] = React.useState(block);
    return (
        <AdminPopover
            edit={edit}
            className={blockUpdate.show ? "" : "opacity-30"}
            title={
                "TextBlock | " + blockUpdate.options?.content ||
                blockUpdate.message
            }
            block={block}
            update={update}
            setBlockUpdate={setBlockUpdate}
        >
            <p
                style={style}
                id="textblock"
                className={cn(
                    "rounded-user bg-user-primary-color text-user-primary-text-color",
                    SHADOW_OPTIONS[theme.profile.design.shadow]?.class,
                    blockUpdate.style?.custom &&
                        BORDER_RADIUS_OPTIONS[blockUpdate.style.corner_radius]
                            ?.class,
                    blockUpdate.style?.custom &&
                        SHADOW_OPTIONS[blockUpdate.style.shadow]?.class,
                    blockUpdate.style?.custom &&
                        FONT_SIZE_OPTIONS[blockUpdate.style.font_size]?.class,
                    "w-full select-none  overflow-hidden text-ellipsis whitespace-pre-wrap text-wrap px-1 py-3 text-center text-xl font-bold shadow-md transition-all duration-150",
                    blockUpdate.name.replaceAll(" ", "-"),
                    "block-" + block.id
                )}
            >
                {blockUpdate.options?.content || blockUpdate.message}
            </p>
        </AdminPopover>
    );
}
